import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as featureFlagsSelectors from 'utils/featureFlags/selectors';
import { getAuthSession } from 'utils/auth/utils';
import { open, close } from 'data/webSocketQCS/webSocketQCSInstance';
import { getReadyState } from 'data/webSocketQCS/webSocketQCSSelectors';
import { sendWebSocketQCSMessage } from 'data/webSocketQCS/webSocketQCSActions';

const WebSocketQCS = () => {
  const featureFlagsError = useSelector(featureFlagsSelectors.getError);
  const featureFlagsLoadPending = useSelector(featureFlagsSelectors.getLoadPending);
  const webSocketEnabled = useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'webSocketQcs'));
  const { datasetId, accessToken } = useSelector(getAuthSession);
  const readyState = useSelector(getReadyState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!featureFlagsLoadPending || featureFlagsError) {
      if (webSocketEnabled) {
        open();
      } else {
        close();
      }
    }
  }, [webSocketEnabled, featureFlagsError, featureFlagsLoadPending]);

  useEffect(() => {
    if (readyState === WebSocket.OPEN) {
      dispatch(sendWebSocketQCSMessage({
        qcsDatasetId: datasetId,
        token: `Bearer ${accessToken}`,
      }));
    }
  }, [readyState, dispatch, datasetId, accessToken]);
  return null;
};

export default WebSocketQCS;


